export const faqsPl = [
  {
    q: "Ile kosztuje MVP aplikacji?",
    a: "Proste MVP webowe to zwykle 40 000–120 000 zł. MVP aplikacji mobilnej (iOS/Android) — najczęściej 80 000–200 000 zł. MVP SaaS z panelem admina i integracjami — często 100 000–250 000 zł. Widełki zależą od zakresu, designu i integracji.",
  },
  {
    q: "Ile kosztuje MVP urządzenia IoT?",
    a: "MVP na DevKit (ESP32, Nordic, STM32) z prostą aplikacją to zwykle 60 000–150 000 zł. MVP z własną PCB, firmware i aplikacją — częściej 150 000–350 000 zł+. Certyfikacja CE to osobny koszt później.",
  },
  {
    q: "Dlaczego wyceny MVP tak mocno się różnią?",
    a: "Bo „MVP” w briefie bywa deskorolką albo niemal gotowym produktem. Najbardziej windują koszt: natywne mobile + BLE, AI/LLM, płatności, role użytkowników, offline, hardware i wymagania regulacyjne (RODO, medtech).",
  },
  {
    q: "Czy da się zrobić MVP za 5 000 USD?",
    a: "Rzadko w sensownym zakresie komercyjnym. Przy takim budżecie realistyczny jest wąski PoC albo prototyp UX, nie pełne MVP z backendem, auth, panelem i paymentami. Na warsztatach pomagamy dopasować zakres do budżetu.",
  },
  {
    q: "Fixed price czy Time & Material — co tańsze?",
    a: "Żadne z definicji. Stała cena jest przewidywalna przy domkniętym zakresie. Time & Material bywa tańsze, gdy uczycie się produktu w trakcie i nie płacicie za bufor ryzyka w ofercie stałej. Często łączymy oba modele.",
  },
  {
    q: "Czy wycena wymaga NDA i briefu?",
    a: "Do orientacyjnych widełek wystarczy opis pomysłu. Do konkretnej oferty — brief, user stories albo warsztaty; przy wrażliwym IP zwykle NDA. Im lepsze materiały wejściowe, tym węższa wycena.",
  },
  {
    q: "Ile kosztują warsztaty produktowe przed wyceną?",
    a: "Zwykle od kilku do kilkunastu tysięcy zł. To inwestycja, która obniża ryzyko przepalenia budżetu developmentu na złym zakresie.",
  },
  {
    q: "Co jest w cenie MVP, a co nie?",
    a: "W typowym zakresie: discovery (lub warsztaty), UX/UI w potrzebnym zakresie, development, podstawowe testy, wdrożenie i dokumentacja startowa. Osobno: utrzymanie 24/7, marketing, sklep App Store/Google (konta), certyfikacja CE, produkcja seryjna hardware.",
  },
] as const;
